import React from 'react'
import { formatDecimalHoursToHM } from '../../utils/formatDecimalHoursToHM'
import { TfiTime } from "react-icons/tfi";
import { IoSettingsOutline } from "react-icons/io5";

export const StageStatsRow = ({ stageData, total }) => {
  const {
    stampStage,
    color,
    title,
    totalQuantity,
    totalStamps,
    totalStampsByHourlyRate,
    totalStampStagePrepareTime,
    totalPrepareOperationsCount
  } = stageData

  const isStampStage = !!stampStage || totalStamps
  const stageColor = !total ? '#E1CCE7' : '#D5E6FF'
  const formatHours = formatDecimalHoursToHM(totalStampsByHourlyRate)
  const totalPrepareTime = formatDecimalHoursToHM(totalStampStagePrepareTime)

  return (
    <div className={`grid grid-cols-[72rem_1fr_1fr] mt-[1px] text-center font-bold text-Regular(16_18) gap-[1px]`}>
      <div className='py-[2.2rem] text-left pl-[2rem]' style={{ backgroundColor: stageColor }}>
        {title}
      </div>
      <div className={`py-[2.2rem] grid grid-cols-[1fr_2fr] gap-[3rem] ${isStampStage ? 'bg-[#FFFFFF]' : 'bg-[#FFFFFF]'}`}>
        <div className={`flex justify-end`}>
          {totalStamps ? `${totalStamps.toLocaleString()}` : ' - '}
        </div>
        {isStampStage && <div className={`flex items-center gap-[2rem]`}>
          <div className={`font-bold flex items-center gap-[0.4rem]`}>
            <TfiTime /> {formatHours}
          </div>
          {totalPrepareTime && <div className={`font-bold flex items-center gap-[0.4rem]`}
               data-tooltip-content='Время настройки оборудования (уже включено в общее время)'
               data-tooltip-place='top'
               data-tooltip-id="settings_tooltip"
          >
            <IoSettingsOutline /> {totalPrepareTime} ({totalPrepareOperationsCount} настр.)
          </div>
          }
        </div>
        }
      </div>
      <div
        className={`py-[2.2rem] bg-[#FFFFFF]`}>{totalQuantity.toLocaleString()}</div>
    </div>
  )
}
